package one.healthium.promo_banner.ui

import kotlinx.serialization.Serializable
import one.healthium.ui.compose.components.banner.BannerData

@Serializable
data class PromoBannerData(
    override val id: String = "promo_banner",
    override val autoDismissDuration: Long? = null,
    val url: String
) : BannerData
